<!-- 注册页面 -->
<template>
    <div>
        <div class="login-cont">
            <div class="cont-2">
                <!--绑定手机号-->
                <div class="col-2">
                    <!--表单-->
                    <div class="form-box">
                        <el-radio-group class="tab-box" v-model="activeTab" size="medium">
                            <el-radio-button label="login">已有账号，请登录</el-radio-button>
                            <el-radio-button label="reg">暂无账号，请注册</el-radio-button>
                        </el-radio-group>
                        <!-- 登录 -->
                        <tab-login v-if="activeTab == 'login'"></tab-login>
                        <!-- 注册 -->
                        <template v-if="activeTab == 'reg'">
                            <tab-reg v-if="regEnabled"></tab-reg>
                            <div v-else class="no-reg">站点未开放注册，请联系站点管理员。</div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import tabLogin from './components/tabLogin'
import tabReg from './components/tabReg'

export default {
    components: { tabLogin, tabReg },
    data() {
        return {
            activeTab: 'login',
            regEnabled: false,
        };
    },
    created() {
        if (sessionStorage.showMode && sessionStorage.showMode.indexOf('registe') > -1) {
            this.regEnabled = true;
        }
    },
    methods: {

    },
};
</script>

<style scoped>
@import "../../../assets/css/login/login.css";
.tab-box{
    display: block;
    margin-bottom: 40px;
}
.tab-box .el-radio-button{
    width: 50%;
}
.tab-box /deep/ .el-radio-button__inner{
    width: 100%;
}
.no-reg{
    text-align: center;
    color: #666;
}
</style>